// Theme: glacial-pulse
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'glacial-pulse',
  name: 'GLACIAL PULSE',
  tagline: 'GLACIAL PULSE',
  description: 'Pulso glacial com reflexo suave e estrutura epica fria.',
  category: 'cosmic-scale',
  tier: 'epic',
  basePrice: 3675,
  swatches: ['#08101A', '#A5F3FC', '#0F1F30', '#CFFAFE'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 28px rgba(0, 0, 0, 0.22)',
      '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--primary) 10%, transparent)'
    },
    shellClasses: 'font-sans theme-glacial-pulse'
  },
  colorVars: {
    '--accent': '#A5F3FC',
    '--accent-foreground': '#08101A',
    '--background': '#08101A',
    '--border': '#2A4A7A',
    '--card': '#0F1F30',
    '--card-border-active': 'rgba(165, 243, 252, 0.48)',
    '--card-completed': '#0F1F30',
    '--card-foreground': '#CFFAFE',
    '--card-glow': 'rgba(165, 243, 252, 0.1)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#EF4444',
    '--destructive-foreground': '#08101A',
    '--foreground': '#CFFAFE',
    '--hold-fill': '#A5F3FC',
    '--input': '#0F1F30',
    '--modal-bg': '#08101A',
    '--modal-border': '#2A4A7A',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#2A4A7A',
    '--muted-foreground': '#CFFAFE',
    '--nav-active': '#A5F3FC',
    '--nav-bg': '#08101A',
    '--popover': '#0F1F30',
    '--popover-foreground': '#CFFAFE',
    '--primary': '#A5F3FC',
    '--primary-foreground': '#08101A',
    '--ring': '#A5F3FC',
    '--secondary': '#2A4A7A',
    '--secondary-foreground': '#CFFAFE',
    '--streak': '#A5F3FC',
    '--success': '#22C55E',
    '--success-foreground': '#08101A',
    '--xp': '#A5F3FC',
    '--xp-bg': '#0F1F30'
  },
  resolvedVars: {
    '--accent': '#A5F3FC',
    '--accent-foreground': '#08101A',
    '--accent-foreground-hsl': '213 53% 7%',
    '--accent-foreground-oklch': 'from #08101A l c h',
    '--accent-hsl': '186 94% 82%',
    '--accent-oklch': 'from #A5F3FC l c h',
    '--background': '#08101A',
    '--background-hsl': '213 53% 7%',
    '--background-oklch': 'from #08101A l c h',
    '--border': '#2A4A7A',
    '--border-hsl': '216 49% 32%',
    '--border-oklch': 'from #2A4A7A l c h',
    '--border-w': '1px',
    '--card': '#0F1F30',
    '--card-border-active': 'rgba(165, 243, 252, 0.48)',
    '--card-completed': '#0F1F30',
    '--card-completed-hsl': '211 52% 12%',
    '--card-completed-oklch': 'from #0F1F30 l c h',
    '--card-foreground': '#CFFAFE',
    '--card-foreground-hsl': '185 96% 90%',
    '--card-foreground-oklch': 'from #CFFAFE l c h',
    '--card-glow': 'rgba(165, 243, 252, 0.1)',
    '--card-hsl': '211 52% 12%',
    '--card-oklch': 'from #0F1F30 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#EF4444',
    '--destructive-foreground': '#08101A',
    '--destructive-foreground-hsl': '213 53% 7%',
    '--destructive-foreground-oklch': 'from #08101A l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #EF4444 l c h',
    '--foreground': '#CFFAFE',
    '--foreground-hsl': '185 96% 90%',
    '--foreground-oklch': 'from #CFFAFE l c h',
    '--hold-fill': '#A5F3FC',
    '--hold-fill-hsl': '186 94% 82%',
    '--hold-fill-oklch': 'from #A5F3FC l c h',
    '--input': '#0F1F30',
    '--input-hsl': '211 52% 12%',
    '--input-oklch': 'from #0F1F30 l c h',
    '--modal-bg': '#08101A',
    '--modal-bg-hsl': '213 53% 7%',
    '--modal-bg-oklch': 'from #08101A l c h',
    '--modal-border': '#2A4A7A',
    '--modal-border-hsl': '216 49% 32%',
    '--modal-border-oklch': 'from #2A4A7A l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#2A4A7A',
    '--muted-foreground': '#CFFAFE',
    '--muted-foreground-hsl': '185 96% 90%',
    '--muted-foreground-oklch': 'from #CFFAFE l c h',
    '--muted-hsl': '216 49% 32%',
    '--muted-oklch': 'from #2A4A7A l c h',
    '--nav-active': '#A5F3FC',
    '--nav-active-hsl': '186 94% 82%',
    '--nav-active-oklch': 'from #A5F3FC l c h',
    '--nav-bg': '#08101A',
    '--nav-bg-hsl': '213 53% 7%',
    '--nav-bg-oklch': 'from #08101A l c h',
    '--popover': '#0F1F30',
    '--popover-foreground': '#CFFAFE',
    '--popover-foreground-hsl': '185 96% 90%',
    '--popover-foreground-oklch': 'from #CFFAFE l c h',
    '--popover-hsl': '211 52% 12%',
    '--popover-oklch': 'from #0F1F30 l c h',
    '--primary': '#A5F3FC',
    '--primary-foreground': '#08101A',
    '--primary-foreground-hsl': '213 53% 7%',
    '--primary-foreground-oklch': 'from #08101A l c h',
    '--primary-hsl': '186 94% 82%',
    '--primary-oklch': 'from #A5F3FC l c h',
    '--radius': '12px',
    '--ring': '#A5F3FC',
    '--ring-hsl': '186 94% 82%',
    '--ring-oklch': 'from #A5F3FC l c h',
    '--secondary': '#2A4A7A',
    '--secondary-foreground': '#CFFAFE',
    '--secondary-foreground-hsl': '185 96% 90%',
    '--secondary-foreground-oklch': 'from #CFFAFE l c h',
    '--secondary-hsl': '216 49% 32%',
    '--secondary-oklch': 'from #2A4A7A l c h',
    '--shadow-card': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--primary) 10%, transparent)',
    '--streak': '#A5F3FC',
    '--streak-hsl': '186 94% 82%',
    '--streak-oklch': 'from #A5F3FC l c h',
    '--success': '#22C55E',
    '--success-foreground': '#08101A',
    '--success-foreground-hsl': '213 53% 7%',
    '--success-foreground-oklch': 'from #08101A l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22C55E l c h',
    '--tint-primary-subtle': 'hsla(186 94% 82% / 0.15)',
    '--xp': '#A5F3FC',
    '--xp-bg': '#0F1F30',
    '--xp-bg-hsl': '211 52% 12%',
    '--xp-bg-oklch': 'from #0F1F30 l c h',
    '--xp-hsl': '186 94% 82%',
    '--xp-oklch': 'from #A5F3FC l c h'
  }
}
